<template>
  <v-card class="text-center pa-4" outlined elevation="2">
    <div
      style="
        border-radius: 200px;
        height: 200px;
        width: 200px;
        background: #f8faf5;
        margin: 0 auto;
      "
    >
      <i class="checkmark">✗</i>
    </div>
    <h1>Error</h1>
    <p v-html="message"></p>
  </v-card>
</template>

<script>
export default {
  name: "shopifyError",
  data: () => {
    return {};
  },
  props: {
    message: null,
  },
};
</script>

<style scoped>
h1 {
  color: #b04b4b;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-weight: 900;
  font-size: 40px;
  margin-bottom: 10px;
}
p {
  color: #5e4040;
  font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  margin: 0;
}
i {
  color: #bc6666;
  font-size: 100px;
  line-height: 200px;
  margin-left: -15px;
}
.card {
  background: white;
  padding: 60px;
  border-radius: 4px;
  box-shadow: 0 2px 3px #c8d0d8;
  display: inline-block;
  margin: 0 auto;
}
</style>
